import React, { useState, useEffect } from "react";

export default function EnquiryModal({ isOpen, onClose }) {
  const [name, setName] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [concern, setConcern] = useState("");
  const [loading, setLoading] = useState(false);
  const [statusMsg, setStatusMsg] = useState(null);

  useEffect(() => {
    if (!isOpen) {
      setName("");
      setContactNo("");
      setConcern("");
      setLoading(false);
      setStatusMsg(null);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatusMsg(null);

    if (!name.trim() || !contactNo.trim() || !concern.trim()) {
      setStatusMsg({ type: "error", text: "Please complete all fields." });
      return;
    }

    setLoading(true);
    try {
      const res = await fetch("/api/enquiries", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: name.trim(), contactNo: contactNo.trim(), concern: concern.trim() }),
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "Request failed");
      }

      setStatusMsg({ type: "success", text: "Enquiry submitted. We will contact you soon." });
      // optionally close after short delay
      setTimeout(() => {
        setLoading(false);
        onClose();
      }, 1000);
    } catch (err) {
      setStatusMsg({ type: "error", text: err.message || "Submission failed" });
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />

      <div className="relative w-full max-w-md mx-4 bg-slate-800 rounded-lg border border-cyan-500/20 shadow-lg p-6">
        <header className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-white">Enquire Now</h3>
          <button onClick={onClose} className="text-slate-300 hover:text-white">
            �
          </button>
        </header>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm text-slate-300 mb-1">Name</label>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full rounded-md border bg-slate-900 border-slate-700 px-3 py-2 text-sm text-white"
              placeholder="Your full name"
              required
            />
          </div>

          <div>
            <label className="block text-sm text-slate-300 mb-1">Contact No</label>
            <input
              value={contactNo}
              onChange={(e) => setContactNo(e.target.value)}
              className="w-full rounded-md border bg-slate-900 border-slate-700 px-3 py-2 text-sm text-white"
              placeholder="+91 9XXXXXXXXX"
              required
            />
          </div>

          <div>
            <label className="block text-sm text-slate-300 mb-1">Your Concern</label>
            <textarea
              value={concern}
              onChange={(e) => setConcern(e.target.value)}
              className="w-full rounded-md border bg-slate-900 border-slate-700 px-3 py-2 text-sm text-white min-h-[90px] resize-none"
              placeholder="Your Mental Health Query"
              required
            />
          </div>

          {statusMsg && (
            <p className={`text-sm ${statusMsg.type === "error" ? "text-rose-400" : "text-emerald-300"}`}>
              {statusMsg.text}
            </p>
          )}

          <div className="flex items-center justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="rounded-md px-4 py-2 text-sm bg-slate-700 text-slate-200 hover:bg-slate-600"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="rounded-md px-4 py-2 text-sm bg-cyan-500 text-slate-900 font-semibold hover:bg-cyan-600 disabled:opacity-60"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}